import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Card, BlockStack, InlineStack, Text } from '@shopify/polaris';

import SettingsPage from '../partials/SettingsPage';

// Placeholder store URLs - the app is not yet listed in either store, so
// these point nowhere useful and the buttons are clearly marked as
// coming soon. Replace with the real listing URLs when they exist.
const GOOGLE_PLAY_URL = '#';
const APP_STORE_URL = '#';
const STORE_LINKS_COMING_SOON = true;

// Entry page for the warehouse app inside Pack Perfect. The mobile app
// gives warehouse staff the better experience (camera scanning, always
// signed in on a dedicated device) so this page pushes admins toward the
// app stores first, but the full web port is available underneath for
// anyone who needs it in the browser.
const WarehouseLanding = () => {
  return (
    <SettingsPage
      title="Warehouse App"
      description="Pick, pack and process batch returns from the warehouse floor. The dedicated mobile app gives your team the best experience - faster barcode scanning with the device camera, and a signed-in session that lives on the warehouse device. Have questions or need some help? Contact us at support@athousandapps.com"
    >
      <Card>
        <BlockStack gap="300">
          <Text as="h2" variant="headingMd">Get the mobile app</Text>
          <Text as="p">
            The Warehouse App is designed for the warehouse floor. For the
            best experience, install it on the devices your pickers, packers
            and returns staff carry - it works much better there than
            accessed through Shopify.
          </Text>
          <InlineStack gap="300">
            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">
              <Button>Get it on Google Play</Button>
            </a>
            {STORE_LINKS_COMING_SOON && <Text as="span" variant="bodySm" tone="subdued"> (coming soon)</Text>}
            <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
              <Button>Download on the App Store</Button>
            </a>
            {STORE_LINKS_COMING_SOON && <Text as="span" variant="bodySm" tone="subdued"> (coming soon)</Text>}
          </InlineStack>
        </BlockStack>
      </Card>

      <Card>
        <BlockStack gap="300">
          <Text as="h2" variant="headingMd">Use the web version</Text>
          <Text as="p">
            No mobile device to hand? The full warehouse app is also
            available right here in the browser. You'll need your employee
            login and a warehouse code (generated under App Settings &gt;
            Login Codes) to get started.
          </Text>
          <InlineStack align="start">
            <Link to="/warehouse/app">
              <Button variant="primary">Continue to Web Version</Button>
            </Link>
          </InlineStack>
        </BlockStack>
      </Card>
    </SettingsPage>
  );
};

export default WarehouseLanding;
